/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SendPaperplaneIcon16Light } from './SendPaperplaneIcon16Light';
import { SendPaperplaneIcon16Regular } from './SendPaperplaneIcon16Regular';
import { SendPaperplaneIcon16Solid } from './SendPaperplaneIcon16Solid';
import { SendPaperplaneIcon20Light } from './SendPaperplaneIcon20Light';
import { SendPaperplaneIcon20Regular } from './SendPaperplaneIcon20Regular';
import { SendPaperplaneIcon20Solid } from './SendPaperplaneIcon20Solid';
import { SendPaperplaneIcon24Regular } from './SendPaperplaneIcon24Regular';
import { SendPaperplaneIcon24Solid } from './SendPaperplaneIcon24Solid';
import { SendPaperplaneIcon32Regular } from './SendPaperplaneIcon32Regular';
import { SendPaperplaneIcon64Regular } from './SendPaperplaneIcon64Regular';
var sizes = {
    16: {
        light: SendPaperplaneIcon16Light,
        regular: SendPaperplaneIcon16Regular,
        solid: SendPaperplaneIcon16Solid,
    },
    20: {
        light: SendPaperplaneIcon20Light,
        regular: SendPaperplaneIcon20Regular,
        solid: SendPaperplaneIcon20Solid,
    },
    24: {
        regular: SendPaperplaneIcon24Regular,
        solid: SendPaperplaneIcon24Solid,
    },
    32: {
        regular: SendPaperplaneIcon32Regular,
    },
    64: {
        regular: SendPaperplaneIcon64Regular,
    },
};
export var SendPaperplaneIcon = forwardRef('SendPaperplaneIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
